module.exports = __webpack_public_path__ + "static/media/logo_eclipse.065601a7.png";